import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { SetField } from '../components/Table/fields/SetField';
import { billingDetails } from './billingDetails';
import { color } from './color';
import { address } from './address';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import {SalesPartnerContact} from "../components/Contacts/SalesPartnerContact";
import {ActivityVisibilityTable} from "../components/SalesPartner/ActivityVisibilityTable";
import {SPRichTextField} from "../components/Table/fields/SPRichTextField";

export const salesPartner: SchemaWithClient<any> = {
  name: 'Sales Partner',
  pluralName: 'Sales Partner',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Contacts',
      name: 'contacts',
      type: 'custom',
      renderer: SalesPartnerContact,
      rendererType: 'contacts',
    },
  ],

  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      name: 'general',
      hasDefaultButtons: true,
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Sales Partner',
              fieldRenderer: SPTextField,
            },
            {
              columnName: 'legal_entity',
              name: 'Legal Entity',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.legalEntity),
            },
            {
              columnName: 'website',
              name: 'Website',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [

            {
              columnName: 'billing_detail',
              name: 'Billing Details',
              fieldRenderer: SPSelectField.tableAdapter(billingDetails),
            },
            {
              columnName: 'payment_method',
              name: 'Payment Method',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.paymentMethod),
            },
            {
              columnName: 'payment_regularity',
              name: 'Payment Regularity',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.paymentRegularity),
            },
            {
              columnName: 'description',
              name: 'Description',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              columnName: 'hotline',
              name: 'Hotline',
              fieldRenderer: SPTextField,
            },

            {
              columnName: 'color',
              name: 'Color',
              fieldRenderer: SPSelectField.tableAdapter(color),
            },
            {
              columnName: 'address',
              name: 'Address',
              fieldRenderer: SPSelectField.tableAdapter(address),
            },
            {
              columnName: 'notes',
              name: 'Notes',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
      ]
    },
    {
      id: 2,
      width: 12,
      label: 'Contacts',
      name: 'contacts',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'contacts',
              fieldRenderer: SalesPartnerContact,
            },
          ],
        },
      ],
    },

    {
      id: 21,
      width: 12,
      label: 'Activity Visibility',
      name: 'activity_visibility',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'activity_visibility',
              fieldRenderer: ActivityVisibilityTable,
            },
          ],
        },
      ],
    },

  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      required: true,
    },
    legal_entity: {
      name: 'Legal Entity',
      fieldRenderer: SelectField.tableAdapter(enumItems.legalEntity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.legalEntity),
      url: enumItems.legalEntity.client.getAllPath,
      tempSchema: enumItems.legalEntity,
      switchboard: true,
    },
    website: {
      name: 'Website',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    description: {
      name: 'Description',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'textarea',
    },
    images: {
      name: 'Images',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    logo: {
      name: 'Logo',
      fieldRenderer: SelectField.tableAdapter(enumItems.file),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.file),
      fieldType: 'image',
      url: enumItems.file.client.getAllPath,
      tempSchema: enumItems.file,
    },
    booking_contacts: {
      name: 'Booking Contact',
      fieldRenderer: SetField.tableAdapter(enumItems.user),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.user),
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
      multiSwitchboard: true,
    },
    /*finance_contacts: {
      name: 'Finance Contact',
      fieldRenderer: SetField.tableAdapter(enumItems.user),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.user),
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
      multiSwitchboard: true,
    },*/
    billing_detail: {
      name: 'Billing Details',
      fieldRenderer: SelectField.tableAdapter(billingDetails),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(billingDetails),
      url: billingDetails.client.getAllPath,
      tempSchema: billingDetails,
      switchboard: true,
    },
    payment_method: {
      name: 'Payment Method',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentMethod),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.paymentMethod
      ),
      url: enumItems.paymentMethod.client.getAllPath,
      tempSchema: enumItems.paymentMethod,
      switchboard: true,
    },
    payment_regularity: {
      name: 'Payment Regularity',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentRegularity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.paymentRegularity
      ),
      url: enumItems.paymentRegularity.client.getAllPath,
      tempSchema: enumItems.paymentRegularity,
      switchboard: true,
    },
    hotline: {
      name: 'Hotline',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    files: {
      name: 'Files',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    notes: {
      name: 'Notes',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'textarea',
    },
    color: {
      name: 'Color',
      fieldRenderer: SelectField.tableAdapter(color),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(color),
      url: color.client.getAllPath,
      tempSchema: color,
      switchboard: true,
    },
    address: {
      name: 'Address',
      fieldRenderer: SelectField.tableAdapter(address),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(address),
      url: address.client.getAllPath,
      tempSchema: address,
      switchboard: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  viewTable: 'sales_partners',
  client: new Client(`/sales-partners`),
};
